// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

// assets
import playStore from "src/assets/images/register/play_store.svg";
import appStore from "src/assets/images/register/app_store.svg";

// animation
import FadeTop from "src/components/Animation/FadeTop";
import FadeRight from "src/components/Animation/FadeRight";
import FadeLeft from "src/components/Animation/FadeLeft";

const AvailableOn = () => {
  return (
    <div className={styles.available}>
      <FadeTop>
        <h1>Available On</h1>
      </FadeTop>
      <div>
        <FadeRight duration={0.5}>
          <a
            href="https://play.google.com/store/apps/details?id=com.music_event_app&hl=en_US&gl=US"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={playStore} alt="play_store" />
          </a>
        </FadeRight>
        <FadeLeft duration={0.5}>
          <a
            href="https://apps.apple.com/us/app/event-moon/id1317300725"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={appStore} alt="app_store" />
          </a>
        </FadeLeft>
      </div>
    </div>
  );
};

export default AvailableOn;
